module.exports = __webpack_public_path__ + "img/icon-complete-app.be1b7685.svg";